import 'core-js';
import './bootstrap';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import AppProvider from './App.Provider';

import 'assets/styles/main.scss';

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
